import React from 'react';
import { ShareLink as FrShareLink } from 'festo-react-ui-kit';
import { routePrefix } from '../../app/App';
import { useTranslation } from '../../hooks/useTranslation';
import { econdaClickEvent } from '../../Econda';
import './ShareLink.scss';

export default function ShareLink(): JSX.Element {
  const t = useTranslation();
  const searchQuery = window.location.search;

  function onClick() {
    econdaClickEvent('results page', 'text link', 'share results', 'open');
  }

  function onClose() {
    econdaClickEvent('results page', 'text link', 'share results', 'close');
  }

  function onOk() {
    econdaClickEvent('results page', 'text link', 'share results', 'click');
  }

  return (
    <FrShareLink
      onLinkClick={onClick}
      onOk={onOk}
      onClose={onClose}
      copiedText={t('resultCopied')}
      copyText={t('resultCopy')}
      shareText={t('resultShare')}
    >
      <div className="fwe-d-flex fwe-justify-content-center">
        <img width="33.33%" height="33.33%" src={`${routePrefix()}qr-code${searchQuery}`} alt="QR-Code" />
      </div>
    </FrShareLink>
  );
}
